import { useState } from "react";
import { useQuery } from "react-query";
import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { getPublishers } from "../../services/api/publishers";
import { ActivityDialog } from "./ActivityDialog";
import Seo from "../../../../ui/components/Seo/Seo";

export function PublishersPage() {
  const [activeName, setActiveName] = useState<string | null>(null);

  const publishersQuery = useQuery(["publishers"], getPublishers);
  const publishers = publishersQuery.data ?? [];

  return (
    <Flex direction="column" h="100%" overflow="hidden">
      <Seo
        title="Видавництва — Панель адміністратора"
        description="Керування видавництвами"
        noindex
      />
      <Flex
        as="header"
        flex="0 0 auto"
        align="center"
        bg="white"
        borderBottom="1px solid"
        borderColor="blackAlpha.100"
        px={6}
        py={4}
      >
        <Heading size="lg" fontWeight="medium" letterSpacing="wide" textTransform="uppercase">
          {"Видавництва"}
        </Heading>
      </Flex>

      {publishersQuery.isLoading ? (
        <Center flex="1">
          <Spinner color="brand.orange" />
        </Center>
      ) : publishers.length === 0 ? (
        <Center flex="1">
          <Text color="gray.500">{"Немає результатів"}</Text>
        </Center>
      ) : (
        <Box
          flex="1 1 auto"
          minH={0}
          overflowY="auto"
          m={6}
          bg="white"
          border="1px solid"
          borderColor="blackAlpha.100"
          borderRadius="lg"
          boxShadow="sm"
        >
          <Table size="sm" variant="simple">
            <Thead position="sticky" top={0} zIndex={1} bg="gray.50">
              <Tr>
                <Th>{"Логотип"}</Th>
                <Th>{"Назва"}</Th>
                <Th isNumeric>{"Відсоток з продажу"}</Th>
                <Th>{"Активність"}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {publishers.map((p) => (
                <Tr key={p.id}>
                  <Td>
                    <Image
                      src={p.logoUrl || "/book-placeholder.png"}
                      fallbackSrc="/book-placeholder.png"
                      alt={p.name}
                      boxSize="40px"
                      objectFit="contain"
                      borderRadius="md"
                      bg="blackAlpha.50"
                    />
                  </Td>
                  <Td>
                    <Text noOfLines={2}>{p.name}</Text>
                  </Td>
                  <Td isNumeric>{Math.round(p.revenuePercent * 100)}%</Td>
                  <Td>
                    <Button size="sm" variant="link" colorScheme="orange" onClick={() => setActiveName(p.name)}>
                      {"Переглянути"}
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}

      <ActivityDialog publisherName={activeName} onClose={() => setActiveName(null)} />
    </Flex>
  );
}
